<template style="height:40px;margin-bottom: 0px;">
  <el-row style="height:40px;margin-bottom: 0px;">
    <el-col :span="24" style="padding-left:0px;margin: 0px; height:40px;">
      <div class="grid-content bg-purple-dark">
          <el-tabs v-model="editableTabsValue" type="card" editable @edit="handleTabsEdit" style="">
          <router-view />

        <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" style="padding-top: 0px;margin-bottom: 0px;margin-top: 20px;">
        
          <!-- <tab-component :is=item.content></tab-component> -->
        </el-tab-pane>
      </el-tabs>
      </div>
    </el-col>
</el-row>

</template>
<script>
import List from './List' 

  export default {
    data() {
      return {
        editableTabsValue: '1',
        editableTabs: [{
          title: '档案查询',
          name: '1',
          content: 'List',
        }, {
          title: '团体发布',
          name: '2',
          content: '团体发布'
        }, {
          title: '测评查询系统',
          name: '3',
          content: '测评查询系统'
        }, {
          title: '预约发布',
          name: '4',
          content: '预约发布'
        }],
        tabIndex: 4,
        // cdcd:'<List />'

      }
    },
    components:{
      List
      // 'List':List
    },
    methods: {
      handleTabsEdit(targetName, action) {
        if (action === 'add') {
          let newTabName = ++this.tabIndex + '';
          this.editableTabs.push({
            title: 'New Tab',
            name: newTabName,
            content: 'New Tab content'
          });
          this.editableTabsValue = newTabName;
        }
        if (action === 'remove') {
          let tabs = this.editableTabs;
          let activeName = this.editableTabsValue;
          if (activeName === targetName) {
            tabs.forEach((tab, index) => {
              if (tab.name === targetName) {
                let nextTab = tabs[index + 1] || tabs[index - 1];
                if (nextTab) {
                  activeName = nextTab.name;
                }
              }
            });
          }
          this.editableTabsValue = activeName;
          this.editableTabs = tabs.filter(tab => tab.name !== targetName);
        }
      }
    }
  }
</script>
<style scoped>
  .el-main{padding-top: 0px!important; }
  .el-tabs__header {
    padding: 0;
    position: relative;
    
}
.grid-content{background-color: #fff;height: 40px;}
.el-row {
    margin-bottom: 0px!important;
}
</style>